module.exports = __webpack_public_path__ + "img/姜黄.f119463f.jpg";